import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import * as authActions from './actions.auth';
import { of } from 'rxjs';

@Injectable()
export class AuthEffect  {

  constructor(
    private readonly routers: Router,
    private readonly store: Store,
    private readonly actions$: Actions,
  ) { }

  login$ = createEffect(() => this.actions$.pipe(
    ofType(authActions.basicLoginActions.tryLogin),
    switchMap(({body}) => of('')),
    tap(res=> {

    }),
    map((loginResponse) => authActions.basicLoginActions.loginSuccess({ loginResponse })),
    catchError((error: any, caught) => {
      this.store.dispatch(authActions.basicLoginActions.loginFailure({ error }));
      return caught;
    })
  ));




}
